import { AreaValueTransfer } from "@/components/excel/schema/label/transfer/area";
import { OtherValueTransfer } from "@/components/excel/schema/label/transfer/other";
import { DateValueTransfer } from "@/components/excel/schema/label/transfer/date";
import { TimeValueTransfer } from "@/components/excel/schema/label/transfer/time";

export const ValueTransfer = {
  ...AreaValueTransfer,
  ...DateValueTransfer,
  ...TimeValueTransfer,
  ...OtherValueTransfer,
};
